module.exports = __webpack_public_path__ + "media/images/favicon/android-icon-48x48-7df3fcfc4c35b68e5db560537592cf92.png";